import { Modelo } from '@ext/index';
import * as Types from './Usuario.types';
import moment, { Moment } from 'moment';

export class IUsuario {

    public constructor( Json: any = null ) {
        if ( Json ) {
            this.Json = Json;
            this.set();
        }
    }

    public Json: any;
    public Existe: boolean = false;
    public Id: number = 0;
    public Nombre: string = '';
    public Apellido: string = '';
    public NickName: string = '';

    public set(): boolean {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Nombre = !this.Json.nombre ? 0 : this.Json.nombre;
        this.Apellido = !this.Json.apellido ? 0 : this.Json.apellido;
        this.NickName = !this.Json.usuario ? 0 : this.Json.usuario;

        this.Existe = true;
        return this.Existe;
    }


    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: IUsuario ) {
        this.Model = Model;
    }

    public Model: IUsuario;
}